import dayjs from "dayjs";
import "dayjs/locale/fr";

dayjs.locale("fr");

export const todayKey = (): string => dayjs().format("YYYY-MM-DD");

export const weekKey = (): string => dayjs().startOf("week").format("YYYY-MM-DD");

export const currentHour = (): number => dayjs().hour();

export const isThisWeek = (iso: string): boolean =>
  dayjs(iso).isAfter(dayjs().subtract(7, "day"));

export const greeting = (): string => {
  const h = dayjs().hour();
  if (h < 12) return "Bonjour";
  if (h < 18) return "Bel après-midi";
  return "Belle soirée";
};

export const prettyToday = (): string => {
  const s = dayjs().format("dddd D MMMM");
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const isFriday = (): boolean => dayjs().day() === 5;
